import React from 'react'
import {getRapid} from '../../services'

export function Download({href, ctaLbl, rapid = {}}) {
  const onClick = () => {
    const rapidInstance = getRapid()
    
    const tarObj = rapidInstance._normalizeTar(href)

    const params = {
      ...tarObj,

      itc: 0,
      cpos: 1,
      elem: 'btn',
      ll1: rapid.ll1,
    }

    rapidInstance.beaconClick(rapid.sec, ctaLbl, rapid.pos, params)
  }

  return (
    <a
      onClick={onClick}
      href={href}
      className="btn btn-primary rounded-pill"
      role="button"
      target="_blank"
      rel="noopener">
      {ctaLbl}
    </a>
  )
}
